// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from './btnPermission'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import 'font-awesome/css/font-awesome.css'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'


import mathChangeDate from '@/common/config';
import App from './App.vue'
import router from './router'
import store from './vuex'
import i18n from './i18n/i18n'

// import Print from "@/utils/print";
import Print from 'vue-print-nb'



import FormMaking from '@/components/draggleForm/js/index'


Vue.config.productionTip = false
Vue.config.lang = 'zh-CN'
Vue.use(Print);

Vue.use(ElementUI, {
    size: 'small'
})
Vue.use(VXETable)
Vue.use(mathChangeDate)
Vue.use(FormMaking, {
    lang: 'zh-CN',
    i18n
})


//导航守卫
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') return next();
//   // 判断是否有token 
//   const tokenStr = window.sessionStorage.getItem('token');
//   if (!tokenStr) return next('/login');
//   next();
//   if (store.getters.info.RoleName === '普通用户') {
//     next('/register');
//   } else {
//     next();
//   }

// })

//  路由前置守卫，切换页面时触发
router.beforeEach((to, from, next) => {

    if (window.sessionStorage.getItem('token')) {
        store.dispatch('setToken', store.getters.token);
        var userInfo = JSON.parse(window.sessionStorage.getItem('info'));
        var routerArr = JSON.parse(window.sessionStorage.getItem('Menus'));
        if (to.path === '/login' || to.path === '/register') {
            next();
        } else if (from.path === '/register' && to.path == '/StartAnswering') {
            next();
        } else {
            if (userInfo.RoleName == '普通用户' || userInfo.RoleName == '患者') {
                next(false)
            } else {
                // 如果没有用户信息
                if (!store.getters.info.RoleName) {
                    !async function getAddRouters() {
                        // 先获取用户信息
                        await store.dispatch('getInfo', window.sessionStorage.getItem('token'))
                        await store.dispatch('newRoutes', {
                            menus: store.getters.info.Menus,
                            role: store.getters.info.RoleName
                        })
                        await router.addRoutes(store.getters.addRouters)

                        // 判断跳转的路由是否在菜单权限中
                        var isRouter = false;
                        if (to.path.indexOf('diagnosisManage') != -1 || to.path.indexOf('addPlan') != -1 || to.path.indexOf('introduceDetail') != -1 || to.path.indexOf('scaleKeyword') != -1) {
                            isRouter = true;
                        }
                        routerArr.forEach((item, index) => {
                            if (to.path.indexOf(item.MenuCode) != -1) {
                                isRouter = true;
                            } else {
                                if (item.Children.length > 0) {
                                    item.Children.forEach((item, index) => {
                                        if (to.path.indexOf(item.MenuCode) != -1) {
                                            isRouter = true;
                                        }
                                    });
                                }
                            }
                        });
                        if (isRouter) {
                            var info = JSON.parse(window.sessionStorage.getItem('info'));
                            if (info.RoleID == 1) {
                                next({
                                    path: '/index'
                                });
                            } else {
                                next({
                                    path: '/ordinaryIndex'
                                });
                            }

                        } else {
                            next(false);
                        }
                        // if (store.getters.info.RoleName == "医院管理员") {
                        //     next({
                        //         path: '/index'
                        //     })
                        // } else {

                        //     next({
                        //         path: '/'
                        //     })
                        // }
                    }()
                } else {
                    let is404 = to.matched.some(record => {
                        if (record.meta.role) {
                            return record.meta.role.indexOf(store.getters.info.RoleName) === -1
                        }
                    })
                    var isRouter = false;
                    if (to.path.indexOf('diagnosisManage') != -1 || to.path.indexOf('introduceDetail') != -1 || to.path.indexOf('addPlan') != -1 || to.path.indexOf('scaleKeyword') != -1) {
                        isRouter = true;
                    }
                    routerArr.forEach((item, index) => {
                        if (to.path.indexOf(item.MenuCode) != -1) {
                            isRouter = true;
                        } else {
                            if (item.Children.length > 0) {
                                item.Children.forEach((item, index) => {
                                    if (to.path.indexOf(item.MenuCode) != -1) {
                                        isRouter = true;
                                    }
                                });
                            }
                        }
                    });
                    if (isRouter) {
                        next();
                    } else {
                        next(false);
                    }
                }

            }
        }
    } else {
        if (to.path === '/login' || to.path === '/register' || to.path === '/StartAnswering'|| to.path=="/mentalHealthReport") {
            next()
        } else {
            next({
                name: 'Login'
            });
        }
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js